import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { routerChangeAction, Routes } from "const";

const initialState = {
  fetchingSavingDeposit: false,
  fetchingMutualFund: false,
  fetchingBond: false,
  fetchingStructureNote: false,

  fetchingCustomerCareContact: false,
  customerCareContact: null,

  bankDeposit: {},
  mutualFund: {
    fetchingMutualFundByType: false,
    fetchingTransactionHistory: false,
    fetchingUnitHolder: false,
    unitholders: [],
    filterUnitholder: [],
    summary: {},
    assets: {},
    fundTypeSelected: null,
    currencyTypeSelected: null,
    mutualFundSpecificType: {
      fundList: [],
    },
    fundSelected: null,
    transaction: null,
    filterTransactionType: "All",
    mutualFundFcyList: [],
  },
  bond: {},
  structureNote: {},

  isRmUser: false,
};

const resetMutualFundFilters = (mutualFund) => {
  mutualFund.currencyTypeSelected = null;
  mutualFund.filterUnitholder =
    mutualFund.unitholders.length > 0 ? mutualFund.unitholders.map((u) => u.unitholderNo) : [];
};

const slice = createSlice({
  initialState,
  name: "portfolio",
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      if (payload.location.pathname === Routes.UltraHigh.Portfolio.Home) {
        resetMutualFundFilters(state.mutualFund);
      }
    });
  },
  reducers: {
    reset: () => cloneDeep(initialState),

    getBankDeposit: (state) => {
      state.fetchingSavingDeposit = true;
    },
    getBankDepositSuccess: (state, action) => {
      state.fetchingSavingDeposit = false;
      state.bankDeposit = action.payload.bankDeposit;
    },
    getBankDepositFailure: (state) => {
      state.fetchingSavingDeposit = false;
      state.bankDeposit = {};
    },

    getStructureNote: (state) => {
      state.fetchingStructureNote = true;
    },
    getStructureNoteSuccess: (state, action) => {
      state.fetchingStructureNote = false;
      state.structureNote = action.payload.structureNote;
    },
    getStructureNoteFailure: (state) => {
      state.fetchingStructureNote = false;
      state.structureNote = {};
    },

    getBond: (state) => {
      state.fetchingBond = true;
    },
    getBondSuccess: (state, action) => {
      state.fetchingBond = false;
      state.bond = action.payload;
    },
    getBondFailure: (state) => {
      state.fetchingBond = false;
      state.bond = {};
    },

    getFund: (state) => {
      state.fetchingMutualFund = true;
    },
    getFundSuccess: (state, action) => {
      const data = action.payload;
      state.fetchingMutualFund = false;
      state.mutualFund.summary = {
        totalAmt: data.totalAmt,
        totalCostAmt: data.totalCostAmt,
        upl: data.upl,
        uplPercent: data.uplPercent,
      };
      state.mutualFund.assets = {
        ...data,
        criteries: data.criteries ?? { unitholder: null, currencyType: null },
      };
      state.mutualFund.assets.mutualFundFcyList = data.mutualFundFcyList;
    },
    getFundFailure: (state) => {
      state.fetchingMutualFund = false;
      state.mutualFund.summary = {};
    },

    // Action ใหม่ที่ไม่มีผลกับ store แต่จะให้ saga ทำงาน
    getFundWithUnitholders: () => { },

    getFundByUnitholder: () => { },
    getFundByUnitholderSuccess: (state, action) => {
      state.fetchingMutualFund = false;
      state.mutualFund.assets = action.payload;
    },
    getFundByUnitholderFailure: (state) => {
      state.fetchingMutualFund = false;
      state.mutualFund.assets = {};
    },
    setMutualFundLoading: (state, action) => {
      state.fetchingMutualFund = action.payload;
    },

    getUnitholders: (state) => {
      if (state.mutualFund.unitholders.length === 0) {
        state.mutualFund.fetchingUnitHolder = true;
      }
    },
    getUnitholdersSuccess: (state, action) => {
      if (state.mutualFund.unitholders.length === 0) {
        state.mutualFund.filterUnitholder = [...action.payload.map((u) => u.unitholderNo)];
      }
      state.mutualFund.fetchingUnitHolder = false;
      state.mutualFund.unitholders = action.payload;
    },
    getUnitholdersFailure: (state) => {
      state.mutualFund.fetchingUnitHolder = false;
      state.mutualFund.assets = {};
    },

    filterUnitholderChange: (state, action) => {
      state.mutualFund.filterUnitholder = action.payload;
    },
    viewSpecificFundType: (state, action) => {
      state.mutualFund.fetchingMutualFundByType = true;
      state.mutualFund.fundTypeSelected = action.payload.fundAssetType;
    },
    setCurrencyTypeSelected: (state, action) => {
      state.mutualFund.currencyTypeSelected = action.payload;
    },
    resetCurrencyTypeSelected: (state) => {
      resetMutualFundFilters(state.mutualFund);
    },
    viewSpecificFundTypeSuccess: (state, action) => {
      state.mutualFund.fetchingMutualFundByType = false;
      if (action.payload) {
        state.mutualFund.mutualFundSpecificType = action.payload;
      } else {
        state.mutualFund.mutualFundSpecificType = {
          fundList: [],
          mfTypeTotalAmt: 0,
          mfTypePercentage: 0,
        };
      }
    },
    viewSpecificFundTypeFailure: (state) => {
      state.mutualFund.fetchingMutualFundByType = false;
      state.mutualFund.mutualFundSpecificType = {
        fundList: [],
      };
    },
    viewTransactionHistory: (state, action) => {
      state.mutualFund.fetchingTransactionHistory = true;
      state.mutualFund.fundSelected = action.payload.fund;
    },
    viewTransactionHistorySuccess: (state, action) => {
      state.mutualFund.fetchingTransactionHistory = true;
      state.mutualFund.transaction = action.payload;
    },
    viewTransactionHistoryFailure: (state) => {
      state.mutualFund.fetchingTransactionHistory = true;
      state.mutualFund.transaction = {};
    },

    setFilterTransactionType: (state, action) => {
      state.mutualFund.filterTransactionType = action.payload;
    },

    getCustomerCareContact: (state) => {
      state.fetchingCustomerCareContact = true;
    },
    getCustomerCareContactSuccess: (state, action) => {
      state.fetchingCustomerCareContact = false;
      state.customerCareContact = action.payload;
    },
    getCustomerCareContactFailure: (state) => {
      state.fetchingCustomerCareContact = false;
      state.customerCareContact = null;
    },

    isRmUser: (state) => {
      state.isRmUser = true;
    },
  },
});

export const {
  reset,

  getBankDeposit,
  getBankDepositSuccess,
  getBankDepositFailure,

  getStructureNote,
  getStructureNoteSuccess,
  getStructureNoteFailure,

  getBond,
  getBondSuccess,
  getBondFailure,

  getFund,
  getFundSuccess,
  getFundFailure,
  getFundWithUnitholders,

  getFundByUnitholder,
  getFundByUnitholderSuccess,
  getFundByUnitholderFailure,

  getUnitholders,
  getUnitholdersSuccess,
  getUnitholdersFailure,

  filterUnitholderChange,
  setMutualFundLoading,

  viewSpecificFundType,
  viewSpecificFundTypeSuccess,
  viewSpecificFundTypeFailure,

  viewTransactionHistory,
  viewTransactionHistorySuccess,
  viewTransactionHistoryFailure,

  setFilterTransactionType,

  getCustomerCareContact,
  getCustomerCareContactSuccess,
  getCustomerCareContactFailure,

  setCurrencyTypeSelected,
  resetCurrencyTypeSelected,
  isRmUser,
} = slice.actions;

export default slice;
